/*
Author : Raphaël Dardeau


Markup : 

<a href="/news/Conrad-et-fortin-interdits-d-exercer/516497" data-webview="francefoot://news/516497">Keylor Navas, nouveau titulaire ?</a>


Setup : 

$(function() {
    $("[data-webview]").webviewing();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "webviewing",
        defaults = {};

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.$element = $(this.element);
            this.url = this.$element.data("webview");
            this.$element.attr("href", this.url);
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);